/** Day number shared by every reader; the daily piece itself is chosen by the Reader API. */
export const numeroDeDia = (fecha = new Date()) =>
  Math.floor(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()) / 86400000);
